// Central definition of every column the alert-history widget knows about.
// Alert history is not sortable, so columns only carry a label + default
// visibility. Column visibility is persisted via context.disabledColumns
// (same convention as alertListColumns.js).

export const ALERT_HISTORY_COLUMNS = {
  BeganEnded: { label: 'Began - Ended', defaultVisible: true },
  Duration: { label: 'Duration', defaultVisible: true },
  Source: { label: 'Source', defaultVisible: true },
  Trigger: { label: 'Trigger', defaultVisible: true },
  Clear: { label: 'Clear', defaultVisible: true },
  Actions: { label: 'Actions', defaultVisible: true },
};

// The canonical column order used by the table.
export const COLUMN_ORDER = [
  'BeganEnded',
  'Duration',
  'Source',
  'Trigger',
  'Clear',
  'Actions',
];

// Turn `context.disabledColumns` into a { columnId: bool } visibility map.
export const buildColumnVisibility = (disabledColumns) => {
  const useDefaults = disabledColumns == null;
  const disabledSet = new Set(disabledColumns || []);

  const visibility = Object.entries(ALERT_HISTORY_COLUMNS).reduce((acc, [id, cfg]) => {
    if (useDefaults) {
      acc[id] = cfg.defaultVisible;
    } else {
      acc[id] = !disabledSet.has(id);
    }
    return acc;
  }, {});

  // Guarantee at least one column is visible.
  if (!Object.values(visibility).some(Boolean)) {
    const firstId = COLUMN_ORDER.find((id) => ALERT_HISTORY_COLUMNS[id])
      || Object.keys(ALERT_HISTORY_COLUMNS)[0];
    visibility[firstId] = true;
  }
  return visibility;
};

// Given the current visibility map, produce the next `disabledColumns` array
// to persist in context.
export const toDisabledColumns = (visibility) => Object.entries(visibility)
  .filter(([, isOn]) => !isOn)
  .map(([id]) => id);
